interface TokenExchangeErrorParams {
  status: number;
  body: string;
}

export const EXPECTED_TOKEN_EXCHANGE_FORBIDDEN_STATUS = 403;

export class TokenExchangeError extends Error {
  public readonly status: number;
  public readonly body: string;

  public constructor({ status, body }: TokenExchangeErrorParams) {
    const detail = body.trim();
    super(`Token exchange failed: ${status}${detail ? ` ${detail}` : ""}`);
    this.name = "TokenExchangeError";
    this.status = status;
    this.body = body;
  }
}

export function getTokenExchangeErrorStatus(error: unknown): number | undefined {
  if (error instanceof TokenExchangeError) {
    return error.status;
  }

  return undefined;
}

export function isExpectedTokenExchangeError(error: unknown): boolean {
  return getTokenExchangeErrorStatus(error) === EXPECTED_TOKEN_EXCHANGE_FORBIDDEN_STATUS;
}
